import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ModificationType } from '@entities/Auto';

export const getModifications = createAsyncThunk<ModificationType[], { groupCode: string; markId: number; year: string }>(
  'autoParams/getModifications',
  async ({ groupCode, markId, year }) => {
    return await MyAxios.get(`/api/catalog/v1/get-auto-modification?groupCode=${groupCode}&markId=${markId}&year=${year}`)
      .then(handleResponse)
      .catch(handleError);
  },
);
